import {COUNTRIES, COUNTRY} from './env';

export const CURRENCIES_LIST = ['XAF', 'NGN', 'XOF'] as const;
export type CURRENCIES = typeof CURRENCIES_LIST[number];

export const CURRENCY_MAP: Partial<Record<COUNTRIES, CURRENCIES>> = {
    CAR: 'XAF',
    NG: 'NGN',
    SN: 'XOF',
};

export const CURRENCY = CURRENCY_MAP[COUNTRY] ?? '—';
